export const phoneTypes = {
  mobile: 'mobile',
  landline: 'landline',
  voip: 'voip',
  unknown: 'unknown',
  invalid: 'invalid',
}
